/**
 * The currency module's frontend manifest — and, at the bottom, what other
 * modules may use: the CRM's deal form offers the server's currencies through
 * `useCurrencies`.
 *
 * Its page lives in a **Settings** section the module declares itself; any
 * other module that wants a page there declares the same id, and both land in
 * one section.
 */
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { CURRENCY_PERMISSIONS } from '@forsys/shared';
import { defineFrontendModule } from '../types';
import { DisplayCurrencyPanel } from './DisplayCurrencyPanel';
import RateHistoryPage from './RateHistoryPage';
import RatesPage from './RatesPage';

const ADMIN = [CURRENCY_PERMISSIONS.ADMIN];

export const currencyModule = defineFrontendModule({
  key: 'currency',
  sections: [{ id: 'settings', titleKey: 'currency:nav.section.settings', order: 900 }],
  pages: [
    {
      path: 'currency/rates',
      element: <RatesPage />,
      anyOf: ADMIN,
      nav: { section: 'settings', labelKey: 'currency:nav.rates', icon: CurrencyExchangeIcon },
    },
    { path: 'currency/rates/:code', element: <RateHistoryPage />, anyOf: ADMIN },
  ],
  slots: {
    // No `anyOf`: everybody with a session has a display currency.
    'profile.sections': [{ id: 'display-currency', component: DisplayCurrencyPanel }],
  },
});

// --- for other modules -------------------------------------------------------

export { preferredFirst, useCurrencies, type Currencies } from './useCurrencies';
